<template>
    <v-row>
        <v-col cols="12" sm="6" md="2">
            <str-work-flow-autocomplete
                v-model="filter.workFlowId"
                :label="$t('module.validation_work_flow')"
            ></str-work-flow-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <v-select
                v-model="filter.modules"
                :items="workFlowModules"
                item-value="id"
                item-text="name"
                label="Modules"
                multiple
                outlined
                dense
                :color="inputColor"
                :background-color="backgroundColor"
                hide-details
                clearable
            ></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <str-all-step-select
                v-model="filter.stepId"
                :label="$t('common.state')"
                except-final
            ></str-all-step-select>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <str-user-autocomplete
                v-model="filter.validatorId"
                :label="$t('common.validator')"
                validator
            ></str-user-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <str-worker-autocomplete
                v-model="filter.workerId"
                :label="$t('module.worker')"
            ></str-worker-autocomplete>
        </v-col>
    </v-row>
</template>

<script>
import useSharedSelectData from "@/use/SharedSelectData.js";
import useSharedData from "@/use/SharedData";

export default {
    name: "ValidationWorkFlowActionFilter",
    props: {
        filter: Object,
    },
    setup() {
        const {inputColor, backgroundColor} = useSharedData();
        const {workFlowModules} = useSharedSelectData();

        return {
            workFlowModules,
            inputColor,
            backgroundColor,
        }
    }
}
</script>

<style scoped>

</style>